// @flow

import React, { Component } from 'react';

import gri from './images/logo-gri.jpg';
import uni from './images/logo-unimore.svg';
import logo from './images/logo-prece.png';
import './App.css';

import injectTapEventPlugin from 'react-tap-event-plugin';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import FontIcon from 'material-ui/FontIcon';
import {BottomNavigation, BottomNavigationItem} from 'material-ui/BottomNavigation';

import { coeff, references } from './constants';
import Formsy from 'formsy-react';
import Scroll from 'react-scroll';
import MediaQuery from 'react-responsive';

import Charts from './Components/Charts';
import Form from './Components/Form';
import ContactForm from './Components/ContactForm';

// import ReactPlayer from 'react-player';
import Dialog from 'material-ui/Dialog';
import Tutorial from './Components/Tutorial';
import CookieBanner from 'react-cookie-banner';
import { cookie } from 'react-cookie-banner';

import ReactGA from 'react-ga';
ReactGA.initialize('UA-191335-60', {
  debug: false,
});

// import Highcharts from 'react-highcharts/themes/dark-unica';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();


var scroll = Scroll.animateScroll;

const zoneColors = [
  '#006400',
  '#7F8400',
  '#FFA500',
  '#F96E00',
  '#EE0000'
];
const printIcon = <FontIcon className="material-icons">print</FontIcon>;
const helpIcon = <FontIcon className="material-icons">help</FontIcon>;
const infoIcon = <FontIcon className="material-icons">info</FontIcon>;
// const movieIcon = <FontIcon className="material-icons">movie</FontIcon>;
const commentIcon = <FontIcon className="material-icons">comment</FontIcon>;

Formsy.addValidationRule('isValueInRange', (values, value, range) => {
  if (value !== '') {
    return value >= range.min && value <= range.max;
  }
  return true;
});

type Props = {
};

class App extends Component {
  props: Props;

  state: {
    hasSubmitted: boolean;
    isPrinting: boolean;
    height: ?number;
    pr: {
      l: Array<number>,
      r: Array<number>
    };
    colors: {
      l: Array<string>,
      r: Array<string>
    };
    videoOpen: boolean;
    tutorialOpen: boolean;
    tutorialDisableShow: boolean;
    disableTutorial: boolean;
    tutorialDisabled: boolean;
    feedbackOpen: boolean;
  };
  content: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      hasSubmitted: false,
      isPrinting: false,
      height: null,
      pr: {
        l: [],
        r: []
      },
      colors: {
        l: [],
        r: []
      },
      videoOpen: !cookie('preceCookiesAccepted'),
      disclaimerOpen: true,
      tutorialOpen: true,
      tutorialDisableShow: true,
      disableTutorial: false,
      tutorialDisabled: cookie('preceTutorialDisabled'),
      feedbackOpen: false,
    };

    if (window.matchMedia) {
        const mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener(mql => {
            if (mql.matches) {
              this.beforePrint();
            } else {
              this.afterPrint();
            }
        });
    }
    window.onbeforeprint = this.beforePrint;
    window.onafterprint = this.afterPrint;
  }

  componentDidMount() {
    ReactGA.set({ page: '/modal/disclaimer' });
    ReactGA.modalview('/disclaimer');
  }

  calculateProbability = (data: Object) => {
    ReactGA.event({
      category: 'App',
      action: 'Data submitted',
    });
    if(!this.state.hasSubmitted) {
      this.setState({hasSubmitted: true});
    }
    scroll.scrollToBottom({duration: 1000});
    let psa = data.psa;
    let age = data.age;
    let stage = data.stage;

    let tumor_positive = data.tumor_positive;

    let total_cores = {
      l: 0,
      r: 0
    };
    let positive_cores = {l: 0, r: 0};
    let high_tumor_cores = {l: 0, r: 0};
    let high_gleason_cores = {l: 0, r: 0};
    let tumor_positive_mean = {l: 0, r: 0};

    for (let key in tumor_positive) {
      if (tumor_positive.hasOwnProperty(key)) {

        let core = parseInt(tumor_positive[key], 10)/100;
        let lobe = key.charAt(0);

        if (!isNaN(core)) {
          total_cores[lobe]++;
          if (core > 0) {
            positive_cores[lobe]++;
            tumor_positive_mean[lobe] += core;
          }
          if (core > 0.6) {
            high_tumor_cores[lobe]++;
          }
          if (data.overall_gleason[key] > 6) {
            high_gleason_cores[lobe]++;
          }
        }
      }
    }

    tumor_positive_mean.l /= total_cores.l;
    tumor_positive_mean.r /= total_cores.r;

    let y = {l:[], r:[]}, pr = {l:[], r:[]}, colors = {l:[], r:[]};

    for (let key in y) {
      if (y.hasOwnProperty(key)) {
        for (let i = 0; i < 5; i++) {
          y[key][i] = coeff.intercept[i] +
                 coeff.age[i]*age +
                 coeff.psa[i]*Math.log(psa)/Math.LN10 +
                 coeff.stage[stage][i] + coeff.positive_cores[i]*positive_cores[key]/total_cores[key] +
                 (positive_cores[key] !== 0 ? coeff.high_gleason_cores[i]*high_gleason_cores[key]/positive_cores[key] +
                 coeff.high_tumor_cores[i]*high_tumor_cores[key]/positive_cores[key] +
                 coeff.tumor_positive_mean[i]*tumor_positive_mean[key] : 0);

          pr[key][i] = 1/(1+Math.exp(-y[key][i]));

          colors[key][i] = zoneColors[4];
          for (let j = 0; j < references.length; j++) {
            if (pr[key][i] < references[j][i]) {
              colors[key][i] = zoneColors[j];
              break;
            }
          }
        }
      }
    }

    this.setState({pr: pr, colors: colors});
  }

  print = () => {
    let originalHeight = this.content.clientHeight, printingHeight = originalHeight + 2000;

    setTimeout(() => {
      this.setState({height: printingHeight});
      window.print();
      this.setState({height: originalHeight});
    }, 200);
  }

  beforePrint = () => {
    this.setState({isPrinting: true});
  };

  afterPrint = () => {
    ReactGA.event({
      category: 'App',
      action: 'Report printed',
    });
    this.setState({isPrinting: false});
  };

  handleVideoOpen = () => {
    ReactGA.set({ page: '/modal/video' });
    ReactGA.modalview('/video');
    this.setState({videoOpen: true});
  };
  handleVideoClose = () => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview('/');
    this.setState({videoOpen: false});
  };

  handleTutorialOpen = () => {
    ReactGA.set({ page: '/modal/tutorial' });
    ReactGA.modalview('/tutorial');
    this.setState({tutorialOpen: true, tutorialDisabled: false, tutorialDisableShow: false});
  };
  handleTutorialClose = () => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview('/');
    if (this.state.disableTutorial) {
      cookie('preceTutorialDisabled', "true");
    }
    this.setState({tutorialOpen: false});
  };

  handleDisclaimerOpen = () => {
    ReactGA.set({ page: '/modal/disclaimer' });
    ReactGA.modalview('/disclaimer');
    this.setState({disclaimerOpen: true});
  };
  handleDisclaimerClose = () => {
    if (this.state.tutorialOpen && !this.state.tutorialDisabled) {
      ReactGA.set({ page: '/modal/tutorial' });
      ReactGA.modalview('/tutorial');
    } else {
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview('/');
    }
    this.setState({disclaimerOpen: false});
  };

  handleFeedbackOpen = () => {
    ReactGA.set({ page: '/modal/feedback' });
    ReactGA.modalview('/feedback');
    this.setState({feedbackOpen: true});
  };
  handleFeedbackClose = () => {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview('/');
    this.setState({feedbackOpen: false});
  };

  handleCheck = () => {
    this.setState({disableTutorial: !this.state.disableTutorial});
  }

  render() {
    // const videoActions = [
    //   <FlatButton
    //     label="Skip intro"
    //     primary={true}
    //     onTouchTap={this.handleVideoClose}
    //     keyboardFocused={true}
    //   />
    // ];

    const disclaimerActions = [
      <FlatButton
        label="Accept"
        primary={true}
        onTouchTap={this.handleDisclaimerClose}
        keyboardFocused={true}
      />
    ];

    const feedbackActions = [
      <FlatButton
        label="Close"
        primary={true}
        onTouchTap={this.handleFeedbackClose}
      />
    ];

    return (
      <div className="App" style={{height: this.state.height}} ref={(content) => {this.content = content; }}>
        <CookieBanner
          message='This website uses cookies. Scrolling on this page means you accept our cookie policy.'
          onAccept={() => {}}
          // link={{msg: 'cookie policy', url: '' }}
          cookie='preceCookiesAccepted'
        />
        <MediaQuery print={false}>
          <div className="App-header">
            <div className="header-content">
              <img src={logo} className="logo" alt="logo" />
              <div className="partners">
                <img src={gri} className="gri-logo" alt="gri-logo" />
                <img src={uni} className="uni-logo" alt="uni-logo" />
              </div>
            </div>
          </div>
        </MediaQuery>
        <MuiThemeProvider muiTheme={getMuiTheme(lightBaseTheme)}>
          <Paper className="main" zDepth={3} transitionEnabled={false} >
            {/* <Dialog
              title="Welcome to PRECE.it"
              open={this.state.videoOpen}
              actions={videoActions}
              modal={false}
              onRequestClose={this.handleVideoClose}
              contentStyle={{ width: 900, maxWidth: 'none' }}
              >
              <ReactPlayer
                url="//www.prece.it/static/media/intro.mp4"
                onEnded={this.handleVideoClose}
                width={854}
                height={480}
                playing
              />
            </Dialog> */}
            <Dialog
              title="Disclaimer"
              open={this.state.disclaimerOpen
                // && !this.state.videoOpen
              }
              actions={disclaimerActions}
              >
              <p>
                The prediction tool located on the PRECE Web site is for general health information only. The prediction tool is not to be used as a substitute for medical advice, diagnosis, or treatment of any health condition or problem.
                Users of the prediction tool should not rely on information provided by the prediction tool for their own health problems. Questions should be addressed to your own physician or other healthcare provider.
              </p>
              <p>
                The authors of the PRECE tool make no warranties, nor express or implied representations whatsoever, regarding the accuracy, completeness, timeliness, comparative or controversial nature, or usefulness of any information contained or referenced in the prediction tools. The authors of the PRECE tool does not assume any risk whatsoever for your use of the prediction tool or the information contained herein. Health related information changes frequently and therefore information contained in the prediction tool may be outdated, incomplete or incorrect.
              </p>
              <p>
                Use of the prediction tool does not create an express or implied physician-patient relationship. The authors of the PRECE tool do not endorse or claim validity for the prediction tools found on the PRECE Web site. PRECE Website does not record specific prediction tool user information and does not contact users of the prediction tool.
              </p>
              <p>
                You are hereby advised to consult with a physician or other professional healthcare provider prior to making any decisions, or undertaking any actions or not undertaking any actions related to any healthcare problem or issue you might have at any time, now or in the future. In using the prediction tool, you agree that neither the authors of the PRECE tool or website nor any other party is or will be liable or otherwise responsible for any decision made or any action taken or any action not taken due to your use of any information presented in the prediction tool.
              </p>
            </Dialog>
            <Tutorial
              open={this.state.tutorialOpen && !this.state.disclaimerOpen && !this.state.tutorialDisabled}
              handleCheck={this.handleCheck}
              handleDismiss={this.handleTutorialClose}
              tutorialDisableShow={this.state.tutorialDisableShow}
            />
            <Dialog
              title="Send us your feedback"
              open={this.state.feedbackOpen}
              modal={false}
              onRequestClose={this.handleFeedbackClose}
              actions={feedbackActions}
              >
              <ContactForm />
            </Dialog>
            <Form handleSubmit={this.calculateProbability} />
              {this.state.hasSubmitted &&
                <div>
                <Divider />
                <Charts pr={this.state.pr} colors={this.state.colors} isPrinting={this.state.isPrinting}/><MediaQuery print={false}>
                <RaisedButton
                  onTouchTap={this.print}
                  label="Print"
                  secondary={true}
                  icon={printIcon}
                  style={{margin: 20}}
                />
              </MediaQuery>
            </div>
          }
          <Divider />
          <BottomNavigation>
            <BottomNavigationItem
              label="How-to"
              icon={helpIcon}
              onTouchTap={this.handleTutorialOpen}
            />
            <BottomNavigationItem
              label="Disclaimer"
              icon={infoIcon}
              onTouchTap={this.handleDisclaimerOpen}
            />
            {/* <BottomNavigationItem
              label="Intro"
              icon={movieIcon}
              onTouchTap={this.handleVideoOpen}
            /> */}
            <BottomNavigationItem
              label="Send feedback"
              icon={commentIcon}
              onTouchTap={this.handleFeedbackOpen}
            />
          </BottomNavigation>
        </Paper>
      </MuiThemeProvider>
    </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/